// extracted by mini-css-extract-plugin
export default {"generalBoschFont":"\"boschsans\",sans-serif !important","ecosystem-container":"our-ecosystem_ecosystem-container__ui-O+"};